module.exports = __webpack_public_path__ + "approach.2NWm-1rW.svg";